import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { endpoint } from "../../../utils/constants/endpoint";
import { headersBase, headersType } from "../../../utils/constants/headersForApi";

export const userAssistenteSmartApi = createApi({
  reducerPath: "userChatConversation",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["chat"],
  endpoints: (builder) => ({
    getUserAllChatConversation: builder.query({
      query: (studioId) => ({
        url: "/chat/conversation?studioId=" + studioId,
        method: "GET",
        headers: headersBase(),
      }),
      providesTags: ["chat"],
    }),

    getUserChatConversationById: builder.query({
      query: (id) => ({
        url: "/chat/" + id,
        method: "GET",
        headers: headersBase(),
      }),
    }),

    getChatCategories: builder.query({
      query: () => ({
        url: "/data/chatcategories",
        method: "GET",
        headers: headersBase(),
      }),
    }),

    doCreateChat: builder.mutation({
      query: (body) => ({
        url: endpoint.USER_CHAT.NEW_CHAT,
        method: "POST",
        headers: headersType(),
        body: body,
      }),
      invalidatesTags: ["chat"],
    }),

    doSendleChat: builder.mutation({
      query: (body) => ({
        url: endpoint.USER_CHAT.CHAT + "/" + body.id,
        method: "POST",
        headers: headersType(),
        body: body,
      }),
      invalidatesTags: ["chat"],
    }),
    doSetReadChat: builder.mutation({
      query: (conversationId) => ({
        url: `/Chat/${conversationId}/setread`,
        method: "POST",
        headers: headersType(),
      }),
      invalidatesTags: ["chat"],
    }),
  }),
});

export const {
  useGetUserAllChatConversationQuery,
  useGetUserChatConversationByIdQuery,
  useGetChatCategoriesQuery,
  useDoCreateChatMutation,
  useDoSendleChatMutation,
  useDoSetReadChatMutation,
} = userAssistenteSmartApi;
